<template>
  <div class="quantity-selector">
    <v-btn
      icon
      rounded
      outlined
      small
      color="primary"
      @click="$emit('decrement')"
    >
      <v-icon>mdi-minus</v-icon>
    </v-btn>

    <span class="quantity-value">{{ quantity }}</span>

    <v-btn
      icon
      rounded
      outlined
      small
      color="primary"
      @click="$emit('increment')"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "QuantitySelector",
  props: {
    quantity: {
      type: Number,
      required: true,
    },
    min: {
      type: Number,
      default: 1,
    },
  },
};
</script>

<style scoped>
.quantity-selector {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f0f0f0;
  padding: 10px;
  border-radius: 10px;
  max-width: 150px;
  gap: 10px;
}
.quantity-value {
  font-size: 1.2rem;
  font-weight: bold;
}
</style>
